import './frontend-widget.scss';
import { render } from '@wordpress/element';
import ShortcodeWidget from './ShortcodeWidget';

console.log('ACB Shortcode Widget script loaded');

// Function to initialize shortcode widgets
function initializeShortcodeWidgets() {
    // Find all shortcode widget containers
    const shortcodeContainers = document.querySelectorAll('[id^="acb-shortcode-widget-"]');
    
    shortcodeContainers.forEach(container => {
        if (container.dataset.initialized === 'true') {
            return; // Skip already initialized widgets
        }
        
        // Get widget configuration from container data attributes
        const config = {
            position: container.dataset.position || 'bottom-right',
            title: container.dataset.title || 'Chat Support',
            description: container.dataset.description || 'Need help? Chat with our team!',
            color: container.dataset.color || '#5A5EB9'
        };
        
        console.log('Initializing shortcode widget:', container.id, config);
        
        // Render the ShortcodeWidget component
        render(<ShortcodeWidget config={config} containerId={container.id} />, container);
        
        // Mark as initialized
        container.dataset.initialized = 'true';
    });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeShortcodeWidgets);

// Also try immediately in case DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShortcodeWidgets);
} else {
    initializeShortcodeWidgets();
}

// Make initialization function available globally for dynamic shortcodes
window.ACB_initShortcodeWidgets = initializeShortcodeWidgets;

// Watch for dynamically added shortcode containers
if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
        let shouldInit = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Check if the added node is a shortcode container
                        if (node.id && node.id.startsWith('acb-shortcode-widget-')) {
                            shouldInit = true;
                        }
                        // Check if any child nodes are shortcode containers
                        const shortcodeContainers = node.querySelectorAll ? node.querySelectorAll('[id^="acb-shortcode-widget-"]') : [];
                        if (shortcodeContainers.length > 0) {
                            shouldInit = true;
                        }
                    }
                });
            }
        });
        
        if (shouldInit) {
            console.log('Dynamic shortcode containers detected, initializing...');
            setTimeout(initializeShortcodeWidgets, 100); // Small delay to ensure DOM is ready
        }
    });
    
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}